import React from "react";
import {Paper, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {notifyError, notifyInfo, notifySuccess} from "./display.notification";
import queryString from "query-string";
import {store} from "../../../helper/store";
import {updateSelectedIHCResult} from "../../../redux_actions/maps.state.action";
import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import {blue, red} from "./annotations_app_utils";
import {IHCConstants} from "../../../utils/const";
import {post_response} from "../../../helper/request";

export const OPERATIONS = IHCConstants.RESULT_OPERATIONS;

export const prepareStatus = ["Prepare Slide", "In progress", "Completed"];

export const annotationActionTooltip =
	["Prepare Slide for Analysis", "Wait for slide to get prepared", "Run IHC Analysis"];

export const runIHCAnalysis = (annotation_ids, params, show_success_msg) => {
	const payload = {
		annotationIds: annotation_ids,
		params: params
	};
	return post_response(`/api/ihc/run/`, payload)
		.then(response => {
			if (show_success_msg) notifySuccess(`ihcAnalysis`, response.data);
		})
		.catch((err) => {
		if (err?.response?.status === 503) {
			notifyError('ihcAnalysis', 'IHC server is down. Please contact Support.')
		} else {
			notifyError(`ihcAnalysis`, `Error caused in IHC analysis`)
		}
	});
}

export const saveIHCCounts = (annotation) =>
	post_response(`/api/ihc/save/`,
		{
			slideId: annotation.slide,
			annotationId: annotation.id,
			result: annotation.result,
		})
		.then(() =>
			notifySuccess(`ihcSave${annotation.id}`, `IHC counts saved for ${annotation.title}`)
		).catch(() => notifyError(`ihcSave${annotation.id}`,
		`Error caused in IHC counts saving for ${annotation.title}`));

export const getIHCResultComponent = (ihcResult) => {
	if (!ihcResult)
		return null;
	let posCount = ihcResult.pos.length;
	let negCount = ihcResult.neg.length;
	let totalCount = posCount + negCount;
	let posPercent = Math.round((posCount / totalCount) * 100);
	let negPercent = Math.round((negCount / totalCount) * 100);
	return <TableContainer component={Paper}>
		<TableHead>
			<TableRow>
				<TableCell>Positive</TableCell>
				<TableCell>Negative</TableCell>
				<TableCell>Total</TableCell>
			</TableRow>
		</TableHead>
		<TableRow>
			<TableCell>{posCount}</TableCell>
			<TableCell>{negCount}</TableCell>
			<TableCell>{totalCount}</TableCell>
		</TableRow>
		<TableRow>
			<TableCell>{posPercent}%</TableCell>
			<TableCell>{negPercent}%</TableCell>
			<TableCell>100%</TableCell>
		</TableRow>
	</TableContainer>
}

export const getIHCResultFeatures = (annotation) => ([
	...annotation.result.pos.map((polygon, index) =>
		new Feature({
			id: `${annotation.id}pos${index}`,
			geometry: new Polygon([polygon]),
			coordinates: polygon,
			color: red,
			preserveFeature: true,
		})),
	...annotation.result.neg.map((polygon, index) =>
		new Feature({
			id: `${annotation.id}neg${index}`,
			geometry: new Polygon([polygon]),
			coordinates: polygon,
			color: blue,
			preserveFeature: true,
		})),
].map(feature => {feature.setId(feature.values_.id); return feature;}))


export const onIHCResultSelect = (mapId, feature) =>
	store.dispatch(updateSelectedIHCResult(mapId, feature));

export const isAddOperation = (operation) => operation &&
	(operation === OPERATIONS.ADD_POSITIVE || operation === OPERATIONS.ADD_NEGATIVE);
